<jmkw-popout-button
  #mockSearchButton
  [iconName]="iconName"
  [contentComponent]="componentRef"
  [tooltipText]="tooltipText"
></jmkw-popout-button>
